const styles = {
    button: {
        fontFamily: 'IBM Plex Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '24px',
        width: '60px',
        height: '40px',
        border: '1px solid #424F49',
        boxSizing: 'border-box',
        borderRadius: '8px',
        background: 'transparent',
        color: '#424F49',
        padding: '0 8px'
    },
    buttonActive: {
        fontFamily: 'IBM Plex Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '24px',
        width: '60px',
        height: '40px',
        border: '1px solid #424F49',
        boxSizing: 'border-box',
        borderRadius: '8px',
        background: '#06844D',
        color: '#FFFFFF',
        padding: '0 8px'
    },
    title: {
        width: '139px',
        height: '20px',

        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '20px',

        letterSpacing: '0.1px',

        color: '#4E6D6F',

        flex: 'none',
        order: '0',
        alignSelf: 'flex-end',
        flexGrow: '0',
        margin: '6px 0px',
        paddingBottom: 0,
        marginLeft: "19px"
    },
    intervalText: {

        fontFamily: 'IBM Plex Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '18px',

        display: 'flex',
        alignItems: 'center',

        color: '#4E6D6F',

        flex: 'none',
        order: '0',
        alignSelf: 'center',
        flexGrow: '0',
        margin: '8px 0px',
        marginLeft: '8px'
    },
    intervalImg: {
        marginRight: '4px'
    },
    flexContainer: {
        display: "flex",
        justifyContent: "center",
        flexDirection: 'column',
        paddingBottom: 0,
        paddingLeft: "24px"
    },
    titleContainer: {
        display: 'flex',
        width: '100%',
        padding: 0
    }
}
export default styles;
